/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S4_Li2Inputs */

const tr_onbilgi_s4_li2 = /** @type {(inputs: Onbilgi_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme, seçilen plan ve süre için peşin olarak tek seferde alınır; taksit uygulanmaz.`)
};

const en_onbilgi_s4_li2 = /** @type {(inputs: Onbilgi_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment is collected in advance in a single amount for the selected plan and term; no instalments.`)
};

const de_onbilgi_s4_li2 = /** @type {(inputs: Onbilgi_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zahlung wird für den gewählten Plan und die gewählte Laufzeit im Voraus in einem Betrag eingezogen; Ratenzahlung gibt es nicht.`)
};

const ru_onbilgi_s4_li2 = /** @type {(inputs: Onbilgi_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплата взимается предоплатой единым платежом за выбранный план и срок; рассрочка не предоставляется.`)
};

/**
* | output |
* | --- |
* | "Payment is collected in advance in a single amount for the selected plan and term; no instalments." |
*
* @param {Onbilgi_S4_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s4_li2 = /** @type {((inputs?: Onbilgi_S4_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S4_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s4_li2(inputs)
	if (locale === "de") return de_onbilgi_s4_li2(inputs)
	if (locale === "ru") return ru_onbilgi_s4_li2(inputs)
	return tr_onbilgi_s4_li2(inputs)
});